import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { getMyApplications } from '../api/myApplications';

// La API manda la fecha de cierre de la oferta como "YYYY-MM-DD"
const formatFinishDate = (finishDate) => {
  const date = dayjs(finishDate);
  return date.isValid() ? date.format('DD/MM/YYYY') : finishDate;
};


const getStateClass = (state) => {
  switch (state) {
    case 'closed':
      return 'rechazada';
    default:
      return 'aprobada';
  }
};

const getStateIcon = (state) => {
  switch (state) {
    case 'closed':
      return '✕';
    default:
      return '✓';
  }
};

const getStateText = (state) => {
  switch (state) {
    case 'closed':
      return 'Cerrada';
    default:
      return 'Activa';
  }
};

export function MyApplicationsTab() {
  const [loading, setLoading] = useState(true);
  const [postulaciones, setPostulaciones] = useState([]);

  useEffect(() => {
    getMyApplications().then(
        (response) => {
            setLoading(false);
            setPostulaciones(response.data?.applications ?? [])
        },
        () => {
          setLoading(false);
        }
    );
  }, [])

  let content;
  if (loading) {
    content = (
      <div className="empty-state">
        <p>Buscando postulaciones...</p>
      </div>
    );
  } else if (postulaciones.length === 0) {
    content = (
      <div className="empty-state">
        <p>No tienes postulaciones activas.</p>
      </div>
    );
  } else {
    content = (
      <div className="postulaciones-list">
        {postulaciones.map((postulacion) => (
          <div key={postulacion.id} className="postulacion-item">
            <div className="postulacion-content">
              <div className="postulacion-info">
                <h3 className="postulacion-titulo">{postulacion.jobOffer?.charge}</h3>
                {/* <div className="postulacion-empresa">
                  <span>{postulacion.empresa}</span>
                </div> */}
                <p className="postulacion-descripcion">{postulacion.jobOffer?.description}</p>
              </div>
              <div className="postulacion-meta">
                <span className={`estado-badge estado-${getStateClass(postulacion.jobOffer?.state)}`}>
                  <span className="estado-icon">{getStateIcon(postulacion.jobOffer?.state)}</span>
                  <span className="estado-text">{getStateText(postulacion.jobOffer?.state)}</span>
                </span>
                {postulacion.jobOffer?.finishDate && (
                  <div className="postulacion-fecha">
                    <span>Cierra el {formatFinishDate(postulacion.jobOffer.finishDate)}</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div>
      <h2 className="section-title">Mis Postulaciones</h2>
      {content}
    </div>
  );
}
